import React, { Suspense } from 'react';
import { Box, Center, Container, HStack, Spinner, useBreakpointValue, VStack } from '@chakra-ui/react';
import { Outlet, useLocation } from 'react-router-dom';
import { MotionBox } from '@components/ui/motion';
import { fadeUp } from '@utils/motion';
import Header from '../Header';
import { Sidebar } from '../Navigation/Sidebar';
import { usePaymentStatus } from '@utils/hooks/queries';

interface LayoutProps {
	maxWidth?: string;
}

const PageFallback = () => (
	<Center h="60vh">
		<Spinner size="xl" color="blue.500" />
	</Center>
);

const Layout: React.FC<LayoutProps> = ({ maxWidth = "2xl" }) => {
	const isMobile = useBreakpointValue({ base: true, xl: false });
	const { paymentFailed } = usePaymentStatus();
	const { pathname } = useLocation();
	const page = (
		<MotionBox key={pathname} variants={fadeUp} initial="initial" animate="animate" h="100%">
			<Suspense fallback={<PageFallback />}>
				<Outlet />
			</Suspense>
		</MotionBox>
	);

	return (
		isMobile ?
		<VStack align={'start'}>
			<Header />
			<Container maxWidth={maxWidth} bg={'gray.50'} w="full" h="100dvh" overflowY="auto" pt={paymentFailed ? 40 : 20} pb={8}>
				{ page }
			</Container>
		</VStack> :
		<HStack align={'start'}>
			<Sidebar />
			<Box flex={1} maxWidth={'full'} bg={'gray.50'} maxH={'100vh'} overflow={"auto"} pt={paymentFailed ? 12 : 0}>
				{ page }
			</Box>
		</HStack>
	);
}

export default Layout;
